/** @format */

export const DOWNLOAD_REG_SCHEMA_START = 'DOWNLOAD_REG_SCHEMA_START';
export const DOWNLOAD_REG_SCHEMA_SUCCESS = 'DOWNLOAD_REG_SCHEMA_SUCCESS';
export const DOWNLOAD_REG_SCHEMA_FAILURE = 'DOWNLOAD_REG_SCHEMA_FAILURE';
